import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PrivateRoute from './routes/privateRoutes';
import PublicRoute from './routes/publicRoutes';
import Login from './pages/auth/login';
import Dashboard from './pages/dashboard';
import Users from './pages/users/users';
import Monitoring from './pages/monitoring/Monitoring';
import Billing from './pages/billing/billing';
import { Toaster } from 'react-hot-toast';
import Subscriptions from './pages/subscriptions/Subscriptions';
import DemoRequests from './pages/demoRequest/demoRequest';

function App() {
  return (
    <>
      <Toaster position="top-right" />
      <Router>
        <Routes>
          <Route path='/' element={<PublicRoute element={Login} />} />
          <Route path='/dashboard' element={<PrivateRoute element={Dashboard} />} />
          <Route path='/users' element={<PrivateRoute element={Users} />} />
          <Route path='/monitoring' element={<PrivateRoute element={Monitoring} />} />
          <Route path='/billing' element={<PrivateRoute element={Billing} />} />
          <Route path='/subscriptions' element={<PrivateRoute element={Subscriptions} />} />
          <Route path='/demo-request' element={<PrivateRoute element={DemoRequests} />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;